/* eslint-disable max-len */
import { SvgProps } from './types'

export const PeopleRisingIcon = ({ color, className }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
  <svg 
    width="58" 
    height="64" 
    viewBox="0 0 58 64" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg" 
    className={className}
  >
    <g clipPath="url(#clip0_333_11668)">
      <path d="M55.7206 14.7516H40.332L42.0072 9.30574L40.332 3.67517H55.7206" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M33.8592 47.4714L30.0057 35.9746C29.579 34.8153 28.4707 34.0446 27.235 34.0446H22.0376L25.5917 24.7262C26.2732 24.7262 26.9165 25.0446 27.3242 25.5924L30.6936 30.0701C31.5917 31.2676 33.2923 31.5032 34.4834 30.5988L39.9611 26.4459C40.872 25.758 41.1013 24.4841 40.4834 23.5223C39.8274 22.4969 38.4643 22.1975 37.4388 22.8599L33.3942 25.4841L30.4388 21.5606C29.6108 20.4586 28.3114 19.809 26.9293 19.809H10.6809C8.37514 19.809 6.29871 21.1911 5.41336 23.3185L1.93565 31.6561C1.52164 32.6497 1.9038 33.8026 2.83374 34.3504C3.94839 35.0064 5.37514 34.5415 5.9038 33.3631L9.16495 26.0128C9.5089 25.2357 10.2796 24.7325 11.1331 24.7325H15.4197L7.79552 56.5478" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.6934 58.0192L18.2857 40.0192H25.8908L29.1647 49.1975" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M24.069 16.5009C26.6248 16.0879 28.362 13.6811 27.9489 11.1252C27.5359 8.56927 25.1291 6.83216 22.5732 7.2452C20.0173 7.65825 18.2802 10.0651 18.6932 12.621C19.1063 15.1768 21.5131 16.914 24.069 16.5009Z" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M56.3572 0.84082V47.1784H37.268V55.1657H19.561V63.1593H0.847656" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_333_11668">
        <rect width="57.1975" height="64" fill={drawColor} transform="translate(0 -0.0078125)"/>
      </clipPath>
    </defs>
  </svg>
  )
}
